// extracted by mini-css-extract-plugin
module.exports = {"productDetails":"ProductDetailsLayout_productDetails___Iujf"};